// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--2J8Bf","buttonText":"button-module--button-text--3us08","buttonIcon":"button-module--button-icon--2wzNK"};